<template>
    <div class="MemberArea MemberArea--create">
        <div class="container">
            <h1 class="MemberArea__title">Complétez votre profil</h1>
            <form @submit="handleSubmit" v-if="$user" class="FormMaterial m-t-30">
                <!-- COMPANY FIELDS -->
                <div v-if="$user.type === $enums.UserType.COMPANY">
                    <input-classic @input="value => handleChange('name', value)"
                                   label="Raison sociale"
                                   v-model="data.name"
                                   :error="errors.name"
                                   :required="true"/>
                    <input-classic @input="value => handleChange('naf', value)"
                                   label="Code NAF" v-model="data.naf"
                                   :error="errors.naf"/>
                    <input-classic @input="value => handleChange('siret', value)"
                                   label="Numéro Siret"
                                   v-model="data.siret"
                                   :error="errors.siret"/>
                </div>
                <!-- LEARNER FIELDS -->
                <div v-else class="row">
                    <div class="col-md-6">
                        <input-classic @input="value => handleChange('firstname', value)"
                                       label="Prénom"
                                       v-model="data.firstname"
                                       :error="errors.firstname" :required="true"/>
                    </div>
                    <div class="col-md-6">
                        <input-classic @input="value => handleChange('lastname', value)"
                                       label="Nom"
                                       v-model="data.lastname"
                                       :error="errors.lastname" :required="true"/>
                    </div>
                </div>
                <!-- COMMONS FIELDS -->
                <input-classic @input="value => handleChange('phone', value)"
                               label="Téléphone"
                               v-model="data.phone"
                               :error="errors.phone"/>
                <input-classic @input="value => handleChange('description', value)"
                               label="Description" type="textarea"
                               v-model="data.description"
                               :error="errors.description"/>
                <input-classic @input="value => handleChange('address.line1', value)"
                               label="Adresse"
                               v-model="data.address.line1"
                               :error="errors['address.line1']"/>
                <div class="row">
                    <div class="col-md-6">
                        <input-classic @input="value => handleChange('address.zip', value)"
                                       label="Code postal"
                                       v-model="data.address.zip"
                                       :error="errors['address.zip']"/>
                    </div>
                    <div class="col-md-6">
                        <input-classic @input="value => handleChange('address.city', value)"
                                       label="Ville"
                                       v-model="data.address.city"
                                       :error="errors['address.city']"/>
                    </div>
                </div>
                <button :disabled="loading" class="Btn Btn--stroked Btn--block m-t-15" @click.prevent="handleSubmit"
                        type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Sauvegarder</span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import Rules from '../validator/rules';
    import validate from "../validator/validator";
    import {isEmpty} from "../utils";
    import {actions} from '../store';
    import UserType from "../enums/UserType";
    import InputClassic from "./InputClassic";
    import ModalBus from "../eventBus";

    export default {
        components: {InputClassic},
        data: function () {
            return {
                data: {
                    firstname: null,
                    lastname: null,
                    name: null,
                    siret: null,
                    naf: null,
                    phone: null,
                    description: null,
                    address: {
                        line1: null,
                        city: null,
                        zip: null
                    }
                },
                loading: false,
                errors: {}
            }
        },
        computed: {
            isLearner() {
                return this.$user?.type === UserType.LEARNER;
            },
            rules() {
                let rules = {
                    phone: [Rules.nullable(), Rules.phone()],
                    description: [Rules.nullable(), Rules.maxLength(255)],
                    'address.line1': [Rules.nullable(), Rules.maxLength(255)],
                    'address.zip': [Rules.nullable(), Rules.numeric(), Rules.length(5)],
                    'address.city': [Rules.nullable(), Rules.maxLength(50)],
                };

                if (this.isLearner) {
                    rules = {
                        ...rules,
                        firstname: [Rules.required()],
                        lastname: [Rules.required()]
                    };
                } else {
                    rules = {
                        ...rules,
                        name: [Rules.required()],
                        siret: [Rules.nullable(), Rules.siret()],
                        naf: [Rules.nullable(), Rules.naf()],
                    }
                }

                return rules;
            }
        },
        methods: {
            handleChange(name) {
                delete this.errors[name];
            },
            async handleSubmit() {
                let data = this.$user.type === this.$enums.UserType.COMPANY ? {
                    name: this.data.name,
                    siret: this.data.siret,
                    naf: this.data.naf,
                    phone: this.data.phone,
                    description: this.data.description,
                    address: {
                        line1: this.data.address.line1,
                        city: this.data.address.city,
                        zip: this.data.address.zip
                    }
                } : {
                    firstname: this.data.firstname,
                    lastname: this.data.lastname,
                    phone: this.data.phone,
                    description: this.data.description,
                    address: {
                        line1: this.data.address.line1,
                        city: this.data.address.city,
                        zip: this.data.address.zip
                    }
                };

                this.loading = true;
                let errors = validate(data, this.rules);

                if (!isEmpty(errors)) {
                    this.errors = errors;
                    this.loading = false;
                    return;
                }

                try {
                    await actions.createProfile(data);
                    window.location.reload();
                } catch (err) {
                    this.loading = false;
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        },
        created() {
            actions.fetchUser();
        }
    }
</script>
